import { styled } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';

export default styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#333',
  },
});
